export default {
  productService: null,
  order: null,
  whOrderExpiration: null,
};
